import { MissionToLecStaff } from '../../lib/types/models/mission-to-lec-staff/mission-to-lec-staff'
import { MissionToLecStaffParam } from '../../lib/types/models/mission-to-lec-staff/mission-to-lec-staff-param'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function cancelLecStaff(input: MissionToLecStaffParam) {
  const { id, userId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.cancelLecStaff.url, { id, userId }))
    .post<MissionToLecStaff>()
}
